import { ChangeDetectionStrategy, Component, SimpleChanges } from '@angular/core';
import { CustomizerComponentHeaderComponent, CustomizerListComponent } from '@app/customizer/components';
import { IconInfoComponent } from '@app/shared/icons/components/icon-info.component';
import { BrandEnum } from '@infrastructure/brand.enum';
import { ComponentVariantModel } from '@models/component-variant';
import { ComponentVariantChangeModel } from '@models/component-variant-change';
import { VariantSizeModel } from '@models/variant-size';
import { TempleInclination, TempleInclinationEnum, templeInclinationToSelectList } from '@models/variant-temple-inclination';
import { TranslatePipe } from '@ngx-translate/core';
import { BrandModeService } from '@services/brandmode.service';
import { ConfigurationService } from '@services/configuration.service';
import { DataApiService } from '@services/data-api.service';
import { EventsService } from '@services/events.service';
import { ImageService } from '@services/image.service';
import { LanguageService } from '@services/language.service';
import { SorterService } from '@services/sorter.service';
import { AngleConstants } from '@shared/angle-constants';
import { BaseCustomizerComponent } from '@shared/base-customizer-component';
import { FadeInOutTransition } from '@shared/transitions/fade-in-out.transition';

@Component({
	selector: 'temple-length',
	templateUrl: 'temple-length.html',
	styleUrls: ['temple-length.scss'],
	animations: [
		FadeInOutTransition()
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CustomizerComponentHeaderComponent, CustomizerListComponent, TranslatePipe, IconInfoComponent]
})

export class TempleLengthComponent extends BaseCustomizerComponent {

	public sizes: Array<VariantSizeModel> = [];
	public templeInclinationList: Array<TempleInclination> = [];
	public selectedLengthIndex: number = 0;
	public selectedTempleInclinationIndex: number;
	public showInfo: boolean;

	brandMode: BrandEnum;

	public brandEnum: typeof BrandEnum = BrandEnum;

	constructor(
		public override events: EventsService,
		public apiService: DataApiService,
		private sorter: SorterService,
		private imageService: ImageService,
		private languageService: LanguageService,
		private brandModeService: BrandModeService,
		public override configurationService: ConfigurationService
	) {
		super(events, apiService, configurationService);
	}

	onChanges(changes: SimpleChanges): void {
		this.selectedLengthIndex = this.sizes.findIndex(x => x.Uuid == this.getSelectedVariant.VariantSize?.Uuid);
		this.selectedTempleInclinationIndex = Number(this.selectedTempleInclination);
	}

	async initData() {
		this.events.showLoader(true);

		this.setImageSliderByName(AngleConstants.Perspective);
		this.sizes = await this.fetch() ?? [];
		this.selectedLengthIndex = this.sizes.findIndex(x => x.Uuid == this.getSelectedVariant.VariantSize?.Uuid);

		this.selectedTempleInclinationIndex = Number(this.selectedTempleInclination);
		this.templeInclinationList = templeInclinationToSelectList(this.languageService);

		this.brandModeService.currentBrand.subscribe(cb => {

			this.brandMode = cb;
		});

		this.events.showLoader(false);
	}

	public templeInclinationStandardInfoImage = () => {
		return this.imageService.GetTempleInclinationStandardInfoImage();
	}

	public templeInclinationLowInfoImage = () => {
		return this.imageService.GetTempleInclinationLowInfoImage();
	}

	onSizeSelect(index: number) {
		this.events.showLoader(true);

		const newVariant = Object.assign(new ComponentVariantModel(this.getSelectedVariant.Discontinued, this.getSelectedVariant.New), this.getSelectedVariant);
		const oldVariant = Object.assign(new ComponentVariantModel(this.getSelectedVariant.Discontinued, this.getSelectedVariant.New), this.getSelectedVariant);
		newVariant.VariantSize = this.sizes[index];
		this.updateComponentSize(new ComponentVariantChangeModel(oldVariant, newVariant, null));
	}

	onInclinationSelect(index: number) {
		this.events.showLoader(true);
		this.updateTempleInclination(index as TempleInclinationEnum);
	}

	async fetch(): Promise<Array<VariantSizeModel> | undefined> {
		const variant = this.getSelectedVariant;
		variant.VariantSizeViewed = true;

		const apidata = await this.configurationService.getVariants(this.configuration?.ModelConfigurationUuid, this.modelGroup, undefined, variant.Uuid);
		await this.RunDisablingSystem(apidata);
		const variantSizes = apidata?.[0].VariantSizes.sort(this.sorter.sortBy(VariantSizeModel));

		return variantSizes;
	}
	getVoid = () => {
		return '';
	}
}
